import { OfferedLanguage } from "../interfaces/language.model";

export const defaultLanguages: OfferedLanguage[] = [
      {
        name: 'French',
        code: 'fr',
        active: true,
        image: 'assets/images/fr_2.png',
      },
      {
        name: 'English',
        code: 'en',
        active: true,
        image: 'assets/images/en.png',
      },
    ];